import { FieldError } from "react-hook-form";

// for components that can't show per-item errors, reduce the nested RHF
// array-item FieldError to the first available message.
export const getFieldArrayErrorMessage = (
  error: FieldError | undefined,
): string | undefined =>
  error?.message ??
  (error
    ? Object.values(error).find(
        (e): e is { message: string } =>
          typeof e === "object" && e !== null && "message" in e,
      )?.message
    : undefined);

/**
 * Adapts a scalar field (value + onChange) to the array-based props
 * expected by upload components (which receive T[] instead of T | null).
 */
export const toArrayFieldProps = <T>(
  value: T | null,
  onChange: (v: T | null) => void,
): { value: T[]; onChange: (v: T[]) => void } => ({
  value: value ? [value] : [],
  onChange: (items) => onChange(items[0] ?? null),
});
